import { Directionality } from "@angular/cdk/bidi";
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, ElementRef, Input, Optional, Renderer2 } from "@angular/core";
import { InputBoolean } from "ng-zorro-antd/core/util";
import { NzTagComponent } from "ng-zorro-antd/tag";
import { UiLabelColor } from "./models/label.models";

/**
 * This component extends the base NzTag component of NG-Zorro.
 * Example usage: https://ng.ant.design/components/tag/en#ng-content.
 * DS epic: https://gtmhub.atlassian.net/browse/GVS-21647.
 * Confluence page: https://gtmhub.atlassian.net/wiki/spaces/DS/pages/2406089035/Label
 *
 * @param uiAccent boolean
 * @param uiColor string
 * @param uiIcon string
 */

@Component({
  selector: "ui-label",
  exportAs: "uiLabel",
  templateUrl: "./label.component.html",
  styleUrls: ["./label.component.less"],
  host: {
    class: "ui-label",
    "[class]": `color ? ('ui-label-' + color) : ''`,
    "[class.accent]": "accent",
  },
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class UiLabelComponent extends NzTagComponent {
  @Input("uiAccent") @InputBoolean() public accent?: boolean;
  @Input("uiColor") public color?: UiLabelColor;
  @Input("uiIcon") public icon?: string;

  constructor(cdr: ChangeDetectorRef, renderer: Renderer2, elementRef: ElementRef, @Optional() directionality: Directionality) {
    super(cdr, renderer, elementRef, directionality);
  }
}
